import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const Indepth = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.indepth.title')}
      contentType="indepth30"
      description={t('page.indepth.desc')}
      outputLabel={t('page.indepth.output')}
    />
  );
};
